/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PricingDto } from './PricingDto';
import {
    PricingDtoFromJSON,
    PricingDtoFromJSONTyped,
    PricingDtoToJSON,
    PricingDtoToJSONTyped,
} from './PricingDto';
import type { BreakdownBeneficiaryDto } from './BreakdownBeneficiaryDto';
import {
    BreakdownBeneficiaryDtoFromJSON,
    BreakdownBeneficiaryDtoFromJSONTyped,
    BreakdownBeneficiaryDtoToJSON,
    BreakdownBeneficiaryDtoToJSONTyped,
} from './BreakdownBeneficiaryDto';

/**
 * Fee entry in a payment breakdown
 * @export
 * @interface BreakdownFeeDto
 */
export interface BreakdownFeeDto {
    /**
     * 
     * @type {string}
     * @memberof BreakdownFeeDto
     */
    feeId: string;
    /**
     * 
     * @type {string}
     * @memberof BreakdownFeeDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof BreakdownFeeDto
     */
    natureCode: string;
    /**
     * 
     * @type {PricingDto}
     * @memberof BreakdownFeeDto
     */
    pricing: PricingDto;
    /**
     * 
     * @type {BreakdownBeneficiaryDto}
     * @memberof BreakdownFeeDto
     */
    beneficiary?: BreakdownBeneficiaryDto;
}

/**
 * Check if a given object implements the BreakdownFeeDto interface.
 */
export function instanceOfBreakdownFeeDto(value: object): value is BreakdownFeeDto {
    if (!('feeId' in value) || value['feeId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('natureCode' in value) || value['natureCode'] === undefined) return false;
    if (!('pricing' in value) || value['pricing'] === undefined) return false;
    return true;
}

export function BreakdownFeeDtoFromJSON(json: any): BreakdownFeeDto {
    return BreakdownFeeDtoFromJSONTyped(json, false);
}

export function BreakdownFeeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreakdownFeeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'feeId': json['feeId'],
        'label': json['label'],
        'natureCode': json['natureCode'],
        'pricing': PricingDtoFromJSON(json['pricing']),
        'beneficiary': json['beneficiary'] == null ? undefined : BreakdownBeneficiaryDtoFromJSON(json['beneficiary']),
    };
}

export function BreakdownFeeDtoToJSON(json: any): BreakdownFeeDto {
    return BreakdownFeeDtoToJSONTyped(json, false);
}

export function BreakdownFeeDtoToJSONTyped(value?: BreakdownFeeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feeId': value['feeId'],
        'label': value['label'],
        'natureCode': value['natureCode'],
        'pricing': PricingDtoToJSON(value['pricing']),
        'beneficiary': BreakdownBeneficiaryDtoToJSON(value['beneficiary']),
    };
}

